import { FC, ReactNode } from 'react';
import './Table.scss';

type TableProps = {
  className?: string;
  content: ReactNode;
  scrollHorizontal?: boolean;
  compact?: boolean;
};

const getTableClassName = (className?: string, compact?: boolean) => {
  const baseClassName = className || 'table custom-table';

  if (!compact) {
    return baseClassName;
  }

  return `${baseClassName} custom-table--compact`;
};

const Table: FC<TableProps> = ({
  className,
  content,
  scrollHorizontal,
  compact,
}) => {
  const wrapperClassName = scrollHorizontal
    ? 'card card-bordered card-preview table-responsive table-scroll-horizontal'
    : 'card card-bordered card-preview';

  return (
    <div className={wrapperClassName}>
      <table className={getTableClassName(className, compact)}>{content}</table>
    </div>
  );
};

export default Table;
